import { http } from "../../../../services/apiCommunicated/Http.interceptor";
import Employee from './interfaces/Employee';
import { GroupEmployees } from './interfaces/GroupEmployees';

const URL: string = '/api/v1';

export const getEmployee = (name: string) => {
    return http.get<Employee[]>(`${URL}/Funcionarios/${name}`);
}

export const getEmployeeGroup = (id: string) => {
    return http.get<Employee[]>(`${URL}/Funcionarios/grupo/${id}`);
}

export const postEmployeeGroup = (groupEmployees: GroupEmployees) => {
    return http.post<GroupEmployees>(`${URL}/grupoFuncionario`, groupEmployees);
}

export const deleteEmployeeGroup = (groupEmployees: GroupEmployees) => {
    return http.post<GroupEmployees>(`${URL}/grupoFuncionario/delete`, groupEmployees);
}

export const getGroup = (id: string) => {
    return http.get<any>(`${URL}/NotificacoesGrupos/notificacao/${id}`);
}